module.exports = __webpack_public_path__ + "static/media/mitsubishi-logo.05ed80d3.svg";